import PropTypes from 'prop-types';
import React from 'react';
import { TextInput } from 'react-admin';

// `onChange` é opcional (ver comentário em CpfInput). O `validate` passado por
// prop agora chega no TextInput — antes era engolido pela desestruturação, então
// o `required()` do RegisterCellphone nunca rodava.
export const CellphoneInput = ({ onChange, ...props }) =>
    <TextInput
        fullWidth
        onChange={(event) => {
            if (onChange) { onChange(event.target.value.replace(/[^\d]/g, '')) }
        }}
        // Campo vazio precisa virar '' e não undefined: com undefined o MUI trata
        // o input como não-controlado e o React reclama na primeira digitação.
        format={(value) => value ?
            value.replace(/(\d{2})(\d)/, "($1) $2")
            :
            ''
        }
        parse={(value) => value.replace(/[^\d]/g, '')}
        {...props}
    />;

CellphoneInput.propTypes = {
    label: PropTypes.string,
    onChange: PropTypes.func,
    source: PropTypes.string.isRequired,
};

CellphoneInput.defaultProps = {
    source: "cellphone",
    label: "Celular"
};
